"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lib = require("../../lib");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ArcModal = function ArcModal(_ref) {
  var children = _ref.children,
    title = _ref.title,
    visible = _ref.visible,
    onSave = _ref.onSave,
    onCancel = _ref.onCancel,
    onSaveloading = _ref.onSaveloading,
    footer = _ref.footer,
    isconfirmModal = _ref.isconfirmModal,
    top = _ref.top,
    centered = _ref.centered,
    disabled = _ref.disabled,
    width = _ref.width,
    closeIcon = _ref.closeIcon,
    className = _ref.className;
  var confirm = _lib.Modal.confirm;
  return !isconfirmModal ? /*#__PURE__*/_react["default"].createElement(_lib.Modal, {
    title: title,
    visible: visible,
    onOk: onSave,
    onCancel: onCancel,
    confirmLoading: onSaveloading,
    footer: footer,
    style: {
      top: top
    },
    centered: centered,
    okButtonProps: {
      disabled: disabled
    },
    cancelButtonProps: {
      disabled: disabled
    },
    width: width,
    closeIcon: closeIcon,
    className: className
  }, children) : confirm({
    title: title,
    visible: isconfirmModal
  });
};
var _default = ArcModal;
exports["default"] = _default;